<template>
	<div class="parts-locations-scanner-card-edit">
		<Dropdown
			label="Barcode Scanner"
			subLabel="Lorem Ipsum Parts, Parts desk, Back Counter, and ROs"
			v-model="localData.barcodeScanner"
			:options="barcodeScannerTypeOptions"
		/>
		<RadioButtonGroup
			v-model="localData.updateWithSelectedScanner"
			:items="selectedScannerTypeOptions"
		/>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import RadioButtonGroup from '@/components/forms/selection-control/radiobutton/radiobutton-group';
import _ from 'lodash';

export default {
	name: 'PartsLocationsScannerCardEdit',
	components: { Dropdown, RadioButtonGroup },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			barcodeScannerTypeOptions: ['Lorem', 'Ipsum', 'Dolor'],
			selectedScannerTypeOptions: [
				{
					disabled: false,
					labelText: 'Pars Order Only',
					value: 'Pars Order Only'
				},
				{
					disabled: false,
					labelText: 'Parts Order and Inventory',
					value: 'Parts Order and Inventory'
				}
			]
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.parts-locations-scanner-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
